import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="main-footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Samuel Neri</h3>
            <p>Desenvolvo sistemas e conecto ferramentas para facilitar o trabalho de quem está do outro lado da tela.</p>
            <div className="footer-social">
              <a href="https://www.linkedin.com/in/samuel-neri-b8841b18a/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn de Samuel Neri">
                <i className="fab fa-linkedin"></i>
              </a>
              <a href="https://github.com/SamuelNeri" target="_blank" rel="noopener noreferrer" aria-label="GitHub de Samuel Neri">
                <i className="fab fa-github"></i>
              </a>
              <a href="mailto:samuell.nerii@gmail.com" aria-label="Enviar e-mail">
                <i className="fas fa-envelope"></i>
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Links Rápidos</h4>
            <ul>
              <li><Link to="/">Início</Link></li>
              <li><Link to="/services">Serviços</Link></li>
              <li><Link to="/projects">Projetos</Link></li>
              <li><Link to="/contact">Contato</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contato</h4>
            <ul>
              <li><i className="fas fa-envelope"></i> samuell.nerii@gmail.com</li>
              <li><i className="fas fa-map-marker-alt"></i> Brasil</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Samuel Neri. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
